import { call, takeLatest, all, put } from '@redux-saga/core/effects';

import { PLAID_LINK_TOKEN_FETCH } from '../actions/plaid/PlaidActionConstants';
import { getLinkToken } from '../../request/plaidRequest';
import {
  fetchLinkTokenSuccess,
  fetchLinkTokenError,
} from '../actions/plaid/PlaidActions';
import { formatErrorMessage } from '../../util/helpers/registerRejectErrorCodeHelper';

function* fetchLinkToken({ payload }) {
  try {
    const { data } = yield call(getLinkToken, payload.ApplicationUid);
    yield put(fetchLinkTokenSuccess(data.PlaidLinkToken));
  } catch (error) {
    const e = formatErrorMessage(error);
    yield call(fetchLinkTokenError, e);
    console.log(error); // eslint-disable-line
  }
}

export default function* plaidSaga() {
  yield all([takeLatest(PLAID_LINK_TOKEN_FETCH, fetchLinkToken)]);
}
